var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDuplicateLink = function SvgDuplicateLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1228_37735)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6586 16.1683C50.6057 11.1154 42.3319 11.1309 37.2945 16.1683C35.0813 18.3815 33.8457 21.2109 33.5778 24.1245C33.4209 25.8308 31.9105 27.0868 30.2042 26.9299C28.4979 26.773 27.2419 25.2626 27.3988 23.5563C27.7927 19.2721 29.6183 15.0692 32.9069 11.7806C40.3623 4.32522 52.565 4.29935 60.0463 11.7806L70.3879 22.1223C77.8459 29.5803 77.8459 41.8037 70.3879 49.2617C62.9325 56.7171 50.7298 56.743 43.2486 49.2617L38.0777 44.0909C36.8661 42.8792 36.8661 40.9148 38.0777 39.7032C39.2893 38.4916 41.2538 38.4916 42.4654 39.7032L47.6362 44.874C52.6891 49.9269 60.9629 49.9114 66.0003 44.874C71.035 39.8393 71.035 31.5447 66.0003 26.51L55.6586 16.1683Z",
    fill: "url(#paint0_linear_1228_37735)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4535 38.9242C44.4007 33.8713 36.1268 33.8868 31.0895 38.9242C26.0547 43.9589 26.0547 52.2534 31.0895 57.2882L41.4311 67.6299C46.484 72.6828 54.7578 72.6673 59.7952 67.6299C62.0084 65.4167 63.244 62.5872 63.5119 59.6737C63.6688 57.9674 65.1792 56.7114 66.8855 56.8683C68.5918 57.0252 69.8478 58.5356 69.6909 60.2419C69.297 64.5261 67.4714 68.729 64.1829 72.0176C56.7275 79.473 44.5248 79.4988 37.0435 72.0176L26.7018 61.6759C19.2438 54.2179 19.2438 41.9945 26.7018 34.5365C34.1572 27.0811 46.3599 27.0552 53.8412 34.5365L59.012 39.7073C60.2236 40.919 60.2236 42.8834 59.012 44.095C57.8004 45.3066 55.836 45.3066 54.6244 44.095L49.4535 38.9242Z",
    fill: "url(#paint1_linear_1228_37735)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.7837,
    cy: 91.5406,
    rx: 28.5434,
    ry: 2.48204,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4993 29.916C40.4639 29.916 33.916 36.4639 33.916 44.4993C33.916 52.5348 40.4639 59.0827 48.4993 59.0827C56.5348 59.0827 63.0827 52.5348 63.0827 44.4993C63.0827 36.4639 56.5348 29.916 48.4993 29.916ZM47.4056 38.666C47.4056 38.0681 47.9014 37.5723 48.4993 37.5723C49.0973 37.5723 49.5931 38.0681 49.5931 38.666V45.9577C49.5931 46.5556 49.0973 47.0514 48.4993 47.0514C47.9014 47.0514 47.4056 46.5556 47.4056 45.9577V38.666ZM49.841 50.8868C49.7681 51.0764 49.666 51.2223 49.5348 51.3681C49.3889 51.4993 49.2285 51.6014 49.0535 51.6743C48.8785 51.7473 48.6889 51.791 48.4993 51.791C48.3098 51.791 48.1202 51.7473 47.9452 51.6743C47.7702 51.6014 47.6098 51.4993 47.4639 51.3681C47.3327 51.2223 47.2306 51.0764 47.1577 50.8868C47.0848 50.7118 47.041 50.5223 47.041 50.3327C47.041 50.1431 47.0848 49.9535 47.1577 49.7785C47.2306 49.6035 47.3327 49.4431 47.4639 49.2973C47.6098 49.166 47.7702 49.0639 47.9452 48.991C48.2952 48.8452 48.7035 48.8452 49.0535 48.991C49.2285 49.0639 49.3889 49.166 49.5348 49.2973C49.666 49.4431 49.7681 49.6035 49.841 49.7785C49.9139 49.9535 49.9577 50.1431 49.9577 50.3327C49.9577 50.5223 49.9139 50.7118 49.841 50.8868Z",
    fill: "#EF5350"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1228_37735",
    x1: 33.6373,
    y1: 11.0503,
    x2: 54.2932,
    y2: 50.0966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1228_37735",
    x1: 27.4322,
    y1: 33.8061,
    x2: 48.0881,
    y2: 72.8525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1228_37735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDuplicateLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "duplicate-link.1f6721f23e7eed48619a4e5a142f0429.svg";